// removed by extract-text-webpack-plugin
module.exports = {"editButton":"RoomSystemsTable-editButton"};